import {Select} from 'antd';
import React, {SyntheticEvent, useEffect, useState} from "react";
import {SelectionMode} from '@models/index';
import {Channel} from "@models/conductor";
import whitListData from "@hocs/withListData";
import channelApi from "@api/channel";


const Option = Select.Option;


export interface ChannelMultiSelectionReturnValue {
  new_conductors: string[];
  deleted_conductors: string[];
  selectedItems: Channel[]
}

export const conductorMultiSelectionDefaultReturnValue: ChannelMultiSelectionReturnValue = {
  new_conductors: [],
  deleted_conductors: [],
  selectedItems: []
};

type ChannelSelectionProps = {
  mode: SelectionMode,
  onChange: (value: ChannelMultiSelectionReturnValue) => void
  selectedChannels: Channel[],
  data: Channel[],
  onScroll: (e: SyntheticEvent) => void,
  handleSearch: (query: string) => void,
  fetchData: (params: object | null) => void,
  filter?: object,
  isFetched: boolean,
  initialValue: Channel[] | Channel | null
}


/**
 * This class handle selection of conductors
 * Use Select fro ant-design because it has on scroll option
 * In terms of lazy loading of data, selected items should bre rendered separated
 * On Change callback return an object from new and deleted conductors
 * @param props
 * @constructor
 */
const ChannelsSelection: React.FC<ChannelSelectionProps> = props => {
  const {handleSearch, onScroll, data = [], initialValue, onChange, fetchData, disabled=false, isFetched, mode = SelectionMode.DEFAULT} = props;
  const defaultValue = mode == SelectionMode.MULTIPLE ? [] : null;
  
  const retrieveValueFromProps = () => {
    if (mode == SelectionMode.MULTIPLE) {
      const returnValue = props.initialValue || [];
      return returnValue.map(item => item.id)
    }
    else {
      return props.initialValue ? props.initialValue.id : null
    }
  };
  
  const [value, setValue] = useState(initialValue ? retrieveValueFromProps() : defaultValue);
  
  useEffect(() => {
    const value = retrieveValueFromProps();
    setValue(value);
  }, [props.initialValue]);
  
  
  /**
   * To handle show selected conductors before fetch data
   */
  const getData = () => {
    if (mode == SelectionMode.MULTIPLE) {
      let returnData = data;
      const selectedValues = props.initialValue || [];
      selectedValues.forEach(conductor => {
        if (returnData.findIndex(opt => opt.id === conductor.id) === -1) {
          returnData.push(conductor)
        }
      });
      
      return returnData;
    }
    else {
      return initialValue && !data.find(opt => opt.id == initialValue.id) ? [...data, initialValue] : data;
    }
  };
  
  const onChangeValue = (newValue, option) => {
    setValue(newValue);
    if (mode == SelectionMode.MULTIPLE) {
      const selectedValues = props.initialValue || [];
      const oldValue = selectedValues.map(cat => cat.id);
      const deleted_conductors = oldValue.filter(item => newValue.findIndex(id => id === item) === -1);
      const new_conductors = newValue.filter(item => oldValue.findIndex(id => id === item) === -1);
      props.onChange({
        deleted_conductors,
        new_conductors,
        selectedItems: option.map(opt => opt.props.conductor)
      });
    }
    else {
      onChange(option.props.conductor)
    }
  };
  
  const onFocus = () => {
    if (isFetched == false) {
      fetchData({});
    }
  };
  
  return (
    <Select
      showSearch
      disabled={disabled}
      mode={mode}
      value={value}
      defaultActiveFirstOption={false}
      showArrow={true}
      filterOption={false}
      onChange={onChangeValue}
      onFocus={onFocus}
      onSearch={handleSearch}
      onPopupScroll={onScroll}
      notFoundContent={null}
    >
      {getData().map(conductor =>
        <Option key={conductor.id} conductor={conductor}>{conductor.title}</Option>
      )}
    </Select>
  );
};

export default whitListData(ChannelsSelection, {
  fetchRequest: channelApi.getList,
  paginationOnScroll: true
});


